// extracted by mini-css-extract-plugin
export default {"block":"ScrollableY_block__VluPJ","viewAll":"ScrollableY_viewAll__aA4cX"};